<div class="checkbox {{id}}"
     [id]="id"
     [class.is-checked]="state == 'checked'"
     [class.is-disabled]="disabled"
     (click)="onChange()"
     (keydown.space)="$event.stopPropagation(); $event.preventDefault(); onChange()"
     tabindex="0">
    <div class="checkbox-icon">
        <i class="fi fi-rs-check" *ngIf="state == 'checked'"></i>
        <i class="unknown" *ngIf="state == 'unknown'"></i>
    </div>
    <div class="checkbox-label">
        <ng-content></ng-content>
    </div>
</div>
